import React from "react";

const QuizImagesIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58.73"
      height="48.235"
      viewBox="0 0 58.73 48.235"
    >
      <g id="db30" transform="translate(0 0)">
        <path
          id="Path_1251"
          data-name="Path 1251"
          d="M77.681,66.088a.773.773,0,0,1-1.093,0l-2.5-2.416v7.549a.781.781,0,0,1-1.562,0V63.673l-2.5,2.416a.859.859,0,0,1-.547.226.721.721,0,0,1-.547-.226.713.713,0,0,1,0-1.057l3.827-3.7c.078-.075.156-.151.234-.151a.883.883,0,0,1,.625,0c.078,0,.156.075.234.151l3.827,3.7A.713.713,0,0,1,77.681,66.088Z"
          transform="translate(-25.356 -28.723)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1252"
          data-name="Path 1252"
          d="M29.6,35.087a4.9,4.9,0,0,1-5-4.831,4.961,4.961,0,1,1,5,4.831Z"
          transform="translate(-15.697 -19.99)"
          fill={fill ? fill : "#4166f8"}
        />
        <path
          id="Path_1253"
          data-name="Path 1253"
          d="M61.933,45.677V20.465A2.311,2.311,0,0,0,59.59,18.2H15.543A2.311,2.311,0,0,0,13.2,20.465V54.508a2.311,2.311,0,0,0,2.343,2.265h34.91a10.745,10.745,0,1,0,11.48-11.1ZM14.762,20.465a.769.769,0,0,1,.781-.755H59.59a.769.769,0,0,1,.781.755V42.582l-11.4-9.662a.842.842,0,0,0-1.015,0L34.208,45.3,27.882,39.26a.84.84,0,0,0-1.015-.075l-12.105,8.53Zm46.39,44.461a8.912,8.912,0,1,1,9.216-8.907A9.133,9.133,0,0,1,61.152,64.925Z"
          transform="translate(-13.2 -18.2)"
          fill={fill ? fill : "#4166f8"}
        />
      </g>
    </svg>
  );
};

export default QuizImagesIcon;
